/* global Success, Error, LoadState, Unauthorized, None, Loading, FilterOptionsTripsTypes, All, ErrorsOnly, NoErrors,
date, tagId, pilotId, zoneId, errorsOnly, from, until */

export enum LoadState {
  None = -1,
  Loading = 0,
  Success = 1,
  Error = 2,
  Unauthorized = 3,
}

export enum FilterOptionsTripsTypes {
  All = 0,
  ErrorsOnly = 1,
  NoErrors = 2,
}

export class FilterOptions {
  date: FilterOptionsDate

  tagId: number

  pilotId: number

  zoneId: number

  errorsOnly: boolean = false

  constructor ({ date, tagId, pilotId, zoneId, errorsOnly }) {
    this.date = {...date}
    this.tagId = tagId
    this.pilotId = pilotId
    this.zoneId = zoneId
    this.errorsOnly = errorsOnly
  }

  static emptyFilters (): FilterOptions {
    return new FilterOptions({
      date: { from: null, until: null },
      tagId: null,
      pilotId: null,
      zoneId: null,
      errorsOnly: false
    })
  }

  get categoryFiltersActive () {
    return !!(this.tagId || this.pilotId || this.zoneId)
  }

  get exportFiltersActive () {
    return !!(this.categoryFiltersActive)
  }

  get filtersActive () {
    return !!(this.categoryFiltersActive || this.date.from || this.date.until || this.errorsOnly)
  }

  public asErrorsOnly () {
    return new FilterOptions({
      date: { ...this.date },
      tagId: null,
      pilotId: null,
      zoneId: null,
      errorsOnly: true
    })
  }

  copy () {
    return new FilterOptions({
      date: { ...this.date },
      tagId: this.tagId,
      pilotId: this.pilotId,
      zoneId: this.zoneId,
      errorsOnly: this.errorsOnly
    })
  }
}

export class FilterOptionsDate {
  from: string

  until: string
}
